export default __webpack_public_path__ + "static/media/ocbc-color.194dc5e0.svg";